import { gql } from 'urql'

import { ESTABLISHMENT } from '@app/queries/fragments'

export const FIND_ESTABLISHMENTS = gql`
  ${ESTABLISHMENT}
  query FindEstablishment(
    $searchTerm: String!
    $where: dfe_establishment_bool_exp
  ) {
    establishments: search_dfe_establishments(
      args: { search_term: $searchTerm }
      limit: 100
      where: $where
    ) {
      ...Establishment
    }

    total: search_dfe_establishments_aggregate(
      args: { search_term: $searchTerm }
      where: $where
    ) {
      aggregate {
        count
      }
    }
  }
`
